import { Directive, Input, ElementRef, HostListener, Renderer2 } from '@angular/core';
import _ from 'lodash';

@Directive({
  selector: '[hostRoomSortDragStart]'
})
export class RoomSortDragStartDirective {
  @Input('draggedClass') draggedClass: string;
  constructor(private el: ElementRef, private rd: Renderer2) { }
  @HostListener('dragstart', ['$event'])
  ondragstart(ev: Event) {
    if (this.el.nativeElement === ev.target) {
      // 先去除所有兄弟元素的draggedClass
      _.forEach(this.el.nativeElement.parentNode.children, item => {
        if (_.indexOf(item.classList, 'on-drag') !== -1) {
          this.rd.removeClass(item, this.draggedClass);
        }
      });
      // 为该元素添加draggedClass
      this.rd.addClass(this.el.nativeElement, this.draggedClass);
    }
  }
}
